var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSair(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#3CDBC0",
    points: "512,236 432,156 403.715,184.284 435.431,216 272,216 272,256 435.43,256 403.714,287.715  431.998,315.999 511.996,236.002  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F41",
    d: "M332.035,316.002v155.926c-0.021,0.025-0.047,0.052-0.071,0.072H112.071 c-0.024-0.021-0.051-0.047-0.071-0.072V40.072c0.021-0.025,0.047-0.051,0.071-0.072h219.893c0.024,0.021,0.05,0.047,0.071,0.072 v115.93h40V40c0-22-18-40-40-40H112C90,0,72,18,72,40v432c0,22,18,40,40,40h220.035c22,0,40-18,40-40V316.002H332.035z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSair);
export default __webpack_public_path__ + "static/media/icon_sair.4abfe30a61745a60e61a41ab4a36c118.svg";
export { ForwardRef as ReactComponent };